import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { observer } from 'mobx-react'
import DetailWrap from './DetailWrap'
import store from './store'
import { MARKETING_CENTER_PATH_A } from '@constant'

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    const {
      location: {
        query: { id }
      }
    } = props

    store.id = id
  }

  componentDidMount() {
    store.getDetail()
  }

  render() {
    let header = [<a href={MARKETING_CENTER_PATH_A}>服务市场</a>, '订单详情']
    return (
      <HeaderView title="订单详情" header={header}>
        <DetailWrap />
      </HeaderView>
    )
  }
}
